<!--
  @修改人：黎柏祺
  @修改时间：2018-12-17
  @修改描述：框架升级
  @版本:v1.0.26
  ------------
  @负责人: 邱凤云
  @创建时间: 2018-01-18
  @版本:v1.0.12
  @描述: 应用日志路径页面
  -->
<template>
  <div class="appLogPathConfig__content">
    <el-form ref="form" :model="form" :inline="true" input-width="auto">  
      <el-form-item :label="$t('logComponentManage.group')">
        <g-select :list="groupList" v-model="form.group" :default-all="true" ></g-select>
      </el-form-item>
      <el-form-item :label="$t('logComponentManage.appName')">
        <g-select :list="selectAppList" v-model="form.appName" :default-all="true"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="e_search" v-g-rac="gRac('appLogPathConfig_search')">{{ $t('common.search') }}</el-button>
        <el-button type="primary" @click="e_add()" v-g-rac="gRac('appLogPathConfig_add')">{{ $t('logComponentManage.add') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <dialog-form
      key="pathForm"
      :title="dialogTitle" 
      :size="1" 
      :label-size="2" 
      :visible.sync="dialogFormShow" 
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :cancel-fun="e_cancel"
      :confirm-fun="e_save">
    </dialog-form>
  </div>
</template>
      
<script >
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import systemSettingBiz from '@/logic/systemSetting/systemSettingBiz.js'
  import dialogForm from '@/components/dialogForm'
  import validateConfig from '@/utils/validate'
  import { extend, getKeyByValue } from '@/utils/tool'
  export default {
    mixins: [rac, dic, table],
    components: {
      dialogForm
    },
    props: ['siteCode'],
    data () {
      const that = this
      return {
        form: {
          group: '',
          appName: ''
        },
        select_enable: {
          true: that.$t('logComponentManage.beUse'),
          false: that.$t('logComponentManage.stopUse')
        },
        selectAppListForAdd: {},
        selectAppList: {},
        tableControl: [
          {
            label: that.$t('common.edit'),
            callback: that.e_add,
            rac: () => that.gRac('appLogPathConfig_amend')
          }, {
            label: that.$t('common.delete'),
            callback: that.e_delete,
            rac: () => that.gRac('appLogPathConfig_delete')
          }
        ],
        dialogFormShow: false,
        dialogTitle: '',
        dialogData: [],
        dialogModel: {},
        dialogFormRule: {},
        isAmend: false,
        init: true,
        groupList: {}
      }
    },
    computed: {
    },
    methods: {
      async waitAppList (group, val) {
        await this.$store.dispatch('resetAppByGroup', {
          siteCode: this.siteCode,
          group: group
        })
        // await this.dGetAppByGroup(this.siteCode, group)
        if (val === 1) {
          this.selectAppList = { ...this.dDictionaryApp[group] }
          this.form.appName = ''
        } else {
          this.selectAppListForAdd = { ...this.dDictionaryApp[group] }
          this.dialogModel.appName = Object.keys(this.selectAppListForAdd)[0]
        }
      },
      async preInitTable () {
        await Promise.all([
          this.dGetGroup(),
          this.dGetDictionaryByCode('logLevel')
        ])
        this.groupList = this.$store.state.dicModule.group
        this.initTable()
        this.setDialogData()
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'logComponentManage.table',
          head: ['appGroup', 'appName', 'path', 'uploadLevel', 'outputLevel', 'enable'],
          requestFun: this.search,
          headOpt: {
            appGroup: {
              formatter: 'Dictionary',
              formatterDic: this.groupList
            },
            enable: {
              formatter: 'Dictionary',
              formatterDic: this.select_enable
            }
          }
        })
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.form)
        let params = new URLSearchParams()
        params.append('siteCode', this.siteCode)
        Object.keys(reqData).map((item) => { params.append(item, reqData[item]) })
        systemSettingBiz.getLog(params).then((data) => {
          this.tData = data
        }).catch((err) => {
          console.error(err)
        })
      },
      setDialogData () {
        this.dialogData = [
          {
            label: this.$t('logComponentManage.groupName'),
            key: 'appGroup',
            inputWidth: '200px',
            type: 'select',
            select: this.groupList
          },
          {
            label: this.$t('logComponentManage.applyName'),
            key: 'appName',
            inputWidth: '200px',
            type: 'select',
            select: this.selectAppListForAdd
          },
          {
            label: this.$t('logComponentManage.path'),
            key: 'path',
            inputWidth: '200px'
          },
          {
            label: this.$t('logComponentManage.reportLevel'),
            key: 'uploadLevel',
            inputWidth: '200px',
            type: 'select',
            select: this.dDictionary.logLevel
          },
          {
            label: this.$t('logComponentManage.printLevel'),
            key: 'outputLevel',
            inputWidth: '200px',
            type: 'select',
            select: this.dDictionary.logLevel
          },
          {
            label: this.$t('logComponentManage.enable'),
            key: 'enable',
            inputWidth: '200px',
            type: 'radio',
            select: this.select_enable
          }
        ]
        this.dialogFormRule = {
          appGroup: [{ ...validateConfig.common.notEmpty }],
          appName: [{ ...validateConfig.common.notEmpty }],
          path: [{ ...validateConfig.common.notEmpty }],
          outputLevel: [{ ...validateConfig.common.notEmpty }],
          uploadLevel: [{ ...validateConfig.common.notEmpty }]
        }
      },
      e_add (rowData) {
        this.dialogFormShow = true
        this.isAmend = rowData !== undefined
        this.dialogTitle = rowData !== undefined ? this.$t('logComponentManage.change') : this.$t('logComponentManage.add')
        this.$set(this.dialogData[0], 'disabled', rowData !== undefined)
        this.$set(this.dialogData[1], 'disabled', rowData !== undefined)
        this.$set(this.dialogFormRule, 'appName', rowData !== undefined ? [] : [{ ...validateConfig.common.notEmpty }])
        if (rowData) {
          this.dialogModel = {
            appGroup: getKeyByValue(this.groupList, rowData.appGroup),
            appName: rowData.appName,
            path: rowData.path,
            outputLevel: rowData.outputLevel,
            uploadLevel: rowData.uploadLevel,
            enable: getKeyByValue(this.select_enable, rowData.enable),
            id: rowData.id
          }
        } else {
          this.dialogModel = {
            appGroup: '',
            appName: '',
            path: '',
            outputLevel: '',
            uploadLevel: '',
            enable: 'true'
          }
        }
      },
      e_cancel () {
        this.dialogFormShow = false
      },
      e_save (data) {
        let param = {...data};
        param.siteCode = this.siteCode
        if (this.isAmend) {
          systemSettingBiz.changeLog(param).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.dialogFormShow = false
              this.e_search()
            }, 500)
          })
        } else {
          systemSettingBiz.addLog(param).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.dialogFormShow = false
              this.e_search()
            }, 500)
          })
        }
      },
      e_delete (rowData) {
        let params = new URLSearchParams()
        params.append('id', rowData.id)
        params.append('siteCode', this.siteCode)
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          systemSettingBiz.deleteLog(params).then((data) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {

        })
      }
    },
    mounted () {},
    watch: {
      'form.group' () {
        this.waitAppList(this.form.group, 1)
      },
      'dialogModel.appGroup' () {
        this.waitAppList(this.dialogModel.appGroup, 2)
      },
      'selectAppListForAdd' () {
        const setDialog = Object.keys(this.selectAppListForAdd).length === 0
        this.$set(this.dialogData[1], 'select', this.selectAppListForAdd)
        this.$set(this.dialogData[1], 'hidden', setDialog)
        if (this.isAmend) {
          this.$set(this.dialogFormRule, 'appName', [])
        } else {
          this.$set(this.dialogFormRule, 'appName', setDialog ? [] : [{ ...validateConfig.common.notEmpty }])
        }
      },
      'groupList' () {
        if (this.dialogData.length !== 0) {
          this.dialogData[0].select = this.groupList
          this.dialogData = extend(true, [], this.dialogData)
        }
      },
      'siteCode' () {
        if (this.init) {
          this.init = false
          this.preInitTable()
          this.e_search()
        } else {
          this.e_search()
        }
      }
    }
  }
</script>
      
      
      
      
      
      
      
      